export default __webpack_public_path__ + "static/media/white_puzzle_icon.50dba241.svg";